export const ALL_DEBAR_USERS_DATA = "all_debar_users_data";
